<template>
    <div class="cockpit-chart">
        <div class="chart-title">{{ title }}</div>
        <div ref="chartContent" class="chart-content" v-if="!noData">
            <svg ref="svgcontent"></svg>
        </div>
        <div class="chart-footer" v-if="!noData">
            <div ref="LGbox" class="legend-chart"></div>
        </div>
        <div class="chart-no-text" v-if="noData">
            <svg class="fail">
                <use :xlink:href="require('@/assets/img/icons/chart-error.svg') + '#layer'"></use>
            </svg>
            <div>{{ $t('chart-no-data') }}</div>
        </div>
    </div>
</template>
<script>
import CockpitChart from '@/components/shared/chart/CockpitChart';
// import paleta from "@/functions/color/paleta.js";
import { palette as paleta } from '@/functions/color/Palette';

export default {
    extends: CockpitChart,
    props: ['title', 'datacontent'],
    props: {
        smoothing: {
            default: true,
        },
        painted: {
            default: true,
        },
    },
    data() {
        return {
            colorList: [],
            cores: [],
            total: 0,
            filtered: [],
            noData: false,
        };
    },
    mounted() {
        var dataset = this.datacontent;
        if (!this.dataset || this.dataset.length <= 0) {
            this.noData = true;
        }
        var areaData = [];

        this.datacontent.xAxis.forEach((t, i) => {
            let stackAreaData = {};
            stackAreaData['xAxis'] = this.datacontent.xAxis[i];
            let prevItemLabel = '';
            this.datacontent.items.forEach((d, j) => {
                stackAreaData[d.label] = d.values[i];
            });
            areaData.push(stackAreaData);
        });

        this.cores = paleta.barColors;

        var margin = { top: 50, right: 30, bottom: 50, left: 50 },
            width = this.$refs.chartContent.offsetWidth - (margin.left + margin.right), // Use the window's width
            height = this.$refs.chartContent.offsetHeight - (margin.bottom + margin.top); // Use the window's height

        var n = this.datacontent.xAxis.length;

        var xScale = this.$d3
            .scaleOrdinal()
            .domain(this.datacontent.xAxis)
            .range(this.getXRange(this.datacontent.xAxis, width));

        // custom invert function
        xScale.invert = (d) => {
            var domain = xScale.domain(),
                range = xScale.range();

            var rangepos = this.$d3.bisect(range, d);
            var minvalue = range[rangepos - 1];
            var maxvalue = range[rangepos];

            if (d - minvalue <= maxvalue - d) {
                return domain[rangepos - 1];
            } else {
                return domain[rangepos];
            }
        };

        var bisectDate = this.$d3.bisector(function (d) {
            return d.xAxis;
        }).right;

        var keys = [];
        areaData.forEach((d) => {
            for (var key in d) {
                if (key != 'xAxis' && keys.indexOf(key) < 0) keys.push(key);
            }
        });

        let yMax = 0;
        areaData.forEach((j) => {
            let areasum = 0;
            keys.forEach((i) => {
                areasum += j[i];
            });
            yMax = yMax < areasum ? areasum : yMax;
        });
        yMax = this.getNextIntegerNumber(yMax);

        var yScale = this.$d3.scaleLinear().domain([0, yMax]).range([height, 0]);

        var color = this.$d3.scaleOrdinal(this.cores);

        var stack = this.$d3.stack().keys(keys);

        var area = this.$d3
            .area()
            .x(function (d, i) {
                return xScale(d.data.xAxis);
            })
            .y0(function (d) {
                return yScale(d[0]);
            })
            .y1(function (d) {
                return yScale(d[1]);
            })
            .curve(this.$d3.curveBasis);

        var div = this.$d3
            .select('body')
            .append('div')
            .attr('class', 'chart-tooltip')
            .style('opacity', 0);

        var svg = this.$d3
            .select(this.$refs.svgcontent)
            .attr('width', width + margin.left + margin.right)
            .attr('height', height + margin.top + margin.bottom)
            .append('g')
            .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

        svg.append('g')
            .attr('class', 'x axis')
            .attr('transform', 'translate(0,' + height + ')')
            .call(this.$d3.axisBottom(xScale));

        svg.append('g').attr('class', 'y axis').call(this.$d3.axisLeft(yScale));

        let alldots = [];

        var layers = stack(areaData);

        var areaDrawn = svg
            .selectAll('.layer')
            .data(layers)
            .enter()
            .append('g')
            .attr('class', 'layer');

        areaDrawn
            .append('path')
            .attr('class', 'areas')
            .transition()
            .duration(400)
            .attr('d', area)
            .style('stroke', function (d, i) {
                return color(d.key);
            })
            .style('stroke-width', 1)
            .style('fill', function (d, i) {
                return color(d.key);
            });

        var d3 = this.$d3;

        //Tooltip Alt
        let adKeys = Object.keys(areaData[0]);
        adKeys.splice(adKeys.indexOf('xAxis'), 1);

        //vertical line
        var vertline = svg
            .append('line')
            .attr('class', 'vertline')
            .attr('x1', 0)
            .attr('x2', 0)
            .attr('y1', 0)
            .attr('y2', height)
            .attr('stroke', 'rgba(255,122,69,0.8)')
            .attr('stroke-width', 2)
            .attr('display', 'none');

        svg.append('rect')
            .attr('class', 'overlay')
            .attr('width', width)
            .attr('height', height)
            .style('fill', 'transparent')
            .on('mouseover', function () {
                div.transition()
                    .duration(200)
                    .style('opacity', this.legendOpacity)
                    .style('color', '#FFF');
                vertline.attr('display', null);
            })
            .on('mouseout', function () {
                div.transition().duration(500).style('opacity', 0);
                vertline.attr('display', 'none');
            })
            .on('mousemove', function () {
                div.style('left', d3.event.pageX - div.node().offsetWidth / 2 + 'px')
                    .style('top', d3.event.pageY - div.node().offsetHeight + 'px')
                    .html('');

                var x0 = xScale.invert(d3.mouse(this)[0]);

                var i = bisectDate(areaData, x0, 1);
                var d0 = areaData[i - 1];
                if (areaData[i]) {
                    var d1 = areaData[i];
                    var dd = x0 - d0.xAxis > d1.xAxis - x0 ? d1 : d0;
                } else {
                    var dd = d0;
                }
                vertline.attr('x1', xScale(x0)).attr('x2', xScale(x0));

                var stackpos = 0;

                layers.forEach((stacks, n) => {
                    stacks.forEach((line, m) => {
                        if (line.data.xAxis == dd.xAxis) {
                            stackpos = m;
                        }
                    });
                });

                div.append('text').html(function (d) {
                    return dd.xAxis + '</br>';
                });

                layers.forEach((rstack, n) => {
                    let ckey = rstack.key;
                    div.append('text').html(
                        rstack.key + ' - ' + rstack[stackpos].data[ckey] + '<br/>'
                    );
                });
            });

        var legends = this.$d3
            .select(this.$refs.LGbox)
            .attr('font-family', 'sans-serif')
            .attr('font-size', 10)
            .attr('text-anchor', 'end')
            .selectAll('.legend')
            .data(color.domain())
            .enter()
            .append('div')
            .attr('class', 'legend-box')
            .on('click', (d) => {
                //
                // Update the array to filter the chart by:
                //

                // add the clicked key if not included:
                if (this.filtered.indexOf(d) == -1) {
                    this.filtered.push(d);
                    // if all bars are un-checked, reset:
                    if (this.filtered.length == color.domain().length) this.filtered = [];
                }
                // otherwise remove it:
                else {
                    this.filtered.splice(this.filtered.indexOf(d), 1);
                }
                //
                // Update the scales for each group(/states)'s items:
                //
                var newKeys = [];
                color.domain().forEach((d) => {
                    if (this.filtered.indexOf(d) == -1 && d) {
                        newKeys.push(d);
                    }
                });

                areaData = [];
                this.datacontent.xAxis.forEach((t, i) => {
                    let stackAreaData = {};
                    stackAreaData['xAxis'] = this.datacontent.xAxis[i];
                    let prevItemLabel = '';
                    this.datacontent.items.forEach((d, j) => {
                        if (newKeys.indexOf(d.label) != -1) {
                            stackAreaData[d.label] = d.values[i];
                        }
                    });
                    areaData.push(stackAreaData);
                });

                yMax = 0;
                areaData.forEach((j) => {
                    let areasum = 0;
                    keys.forEach((i) => {
                        if (newKeys.indexOf(i) == -1) {
                            j[i] = 0;
                        } else {
                            areasum += j[i];
                        }
                    });
                    yMax = yMax < areasum ? areasum : yMax;
                });
                yMax = this.getNextIntegerNumber(yMax);

                var stack2 = this.$d3.stack().keys(newKeys);

                var layers2 = stack2(areaData);

                areaDrawn = svg.selectAll('.layer').remove();

                areaDrawn = svg
                    .selectAll('.layer')
                    .data(layers2)
                    .enter()
                    .append('g')
                    .attr('class', 'layer');

                areaDrawn
                    .append('path')
                    .style('fill', function (d, i) {
                        return color(d.key);
                    })
                    .transition()
                    .duration(400)
                    .attr('d', area);

                // update legend:
                legends.style('opacity', (d) => {
                    if (this.filtered.length) {
                        if (this.filtered.indexOf(d) == -1) {
                            return 1;
                        } else {
                            return 0.4;
                        }
                    } else {
                        return 1;
                    }
                });

                //Tooltip Alt
                adKeys = Object.keys(areaData[0]);
                adKeys.splice(adKeys.indexOf('xAxis'), 1);

                //vertical line
                vertline.remove();
                vertline = svg
                    .append('line')
                    .attr('class', 'vertline')
                    .attr('x1', 0)
                    .attr('x2', 0)
                    .attr('y1', 0)
                    .attr('y2', height)
                    .attr('stroke', 'rgba(255,122,69,0.8)')
                    .attr('stroke-width', 2)
                    .attr('display', 'none');

                svg.selectAll('rect').remove();

                svg.append('rect')
                    .attr('class', 'overlay')
                    .attr('width', width)
                    .attr('height', height)
                    .style('fill', 'transparent')
                    .on('mouseover', function () {
                        div.transition()
                            .duration(200)
                            .style('opacity', this.legendOpacity)
                            .style('color', '#FFF');
                        vertline.attr('display', null);
                    })
                    .on('mouseout', function () {
                        div.transition().duration(500).style('opacity', 0);
                        vertline.attr('display', 'none');
                    })
                    .on('mousemove', function () {
                        div.style('left', d3.event.pageX - div.node().offsetWidth / 2 + 'px')
                            .style('top', d3.event.pageY - div.node().offsetHeight + 'px')
                            .html('');

                        var x0 = xScale.invert(d3.mouse(this)[0]);

                        var i = bisectDate(areaData, x0, 1);
                        var d0 = areaData[i - 1];
                        if (areaData[i]) {
                            var d1 = areaData[i];
                            var dd = x0 - d0.xAxis > d1.xAxis - x0 ? d1 : d0;
                        } else {
                            var dd = d0;
                        }
                        vertline.attr('x1', xScale(x0)).attr('x2', xScale(x0));

                        var stackpos = 0;

                        layers2.forEach((stacks, n) => {
                            stacks.forEach((line, m) => {
                                if (line.data.xAxis == dd.xAxis) {
                                    stackpos = m;
                                }
                            });
                        });

                        div.append('text').html(function (d) {
                            return dd.xAxis + '</br>';
                        });

                        layers2.forEach((rstack, n) => {
                            let ckey = rstack.key;
                            div.append('text').html(
                                rstack.key + ' - ' + rstack[stackpos].data[ckey] + '<br/>'
                            );
                        });
                    });
            });

        legends
            .append('div')
            .style('width', this.legendRectSize + 'px')
            .style('height', this.legendRectSize + 'px')
            .attr('class', 'legend-color-box')
            .style('background', color);

        legends
            .append('p')
            .style('text-transform', 'uppercase')
            .text(function (d) {
                return d;
            });
    },
    watch: {
        data: function (newData) {
            this.drawChart(newData);
        },
    },
    methods: {
        getNextIntegerNumber(v) {
            let iv = Math.floor(v);
            let vs = iv + '';
            let t = vs.length;
            let fn = Number(vs.substring(0, 1));
            let adder = fn > 3 ? 10 ** (t - 1) : 10 ** (t - 2);
            let nv = fn * 10 ** (t - 1) + adder;

            while (nv < v) {
                nv += adder;
            }
            return nv;
        },
        getXRange(xAxis, width) {
            let gap = xAxis.length - 1;
            let mrange = width / (gap == 0 ? 1 : gap);
            return xAxis.map((xa, i) => i * mrange);
        },
        getValue(d) {
            let percent = (d * 100) / this.total;
            return percent;
        },
        getFormattedValue(value) {
            return ('R$' + Math.floor(value * 100) / 100).replace('.', ',');
        },
    },
};
</script>
